import Popup from "react-popup";
import React, { Component } from 'react';
import ConfigService from "../../../services/configuracion/ConfigService";
import { trackPromise } from "react-promise-tracker";
import DatosSocio from "../../generico/DatosSocio"
import authService from "../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faCheck} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery"

const TEXT_ERROR = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";

export default class PopupInscripcionAsamblea extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tieneDosisCompleta: ""
        }
    }

    componentDidMount() {
        $('#modal-inscripcion').on('shown.bs.modal', function (e) {
            console.log(e);
        })
    }

    notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });

    confirmarAgendamiento = () => {
        let { tieneDosisCompleta } = this.state;
        trackPromise(
            ConfigService.agendamientoAsamblea(tieneDosisCompleta)
                .then(({ data }) => {
                    Popup.queue(this.notifiPopup("Info", data.mensajeRetorno));
                })
                .catch(error => {
                    console.log(error);
                    Popup.queue(this.notifiPopup("Error", TEXT_ERROR));
                })
        )
    }

    handleChangeInput = (e) => {
        let tieneDosisCompleta = e.target.value;
        this.setState({ tieneDosisCompleta });
    }

    render() {

        let usuario = authService.getSocio();

        return (
            <div className="modal fade" id="modal-inscripcion" data-backdrop="static" >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <p className="m-0" style={{ fontWeight: 600, fontSize: "1.2rem",fontFamily:"Montserrat-semibold" }}> Agendamiento Obligatorio​ p/ la Asamblea Deliberativa​  (Res. 25.079/22 INCOOP)</p>
                        </div>
                        <div className="modal-body">
                            <div className="callout callout-success importante">
                                <div className="row">
                                    <div className="col-md-12">
                                        <i className="fas fa-exclamation-circle card-fa-icono-info" style={{ marginRight: 5, fontSize: 25 }} />
                                        <p style={{ fontSize: 20, fontFamily:"Montserrat-semibold" }}>¡Importante!</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-justify">
                                        
                                         <p className="texto-importante" >Para asistir a la Asamblea Ordinaria en su parte Deliberativa, el socio debe asistir con su cédula de identidad​ + Carnet de Vacunación.</p>
                                     
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <DatosSocio />
                                </div>
                                <div className="col-lg-2">
                                    <small>Cédula</small>
                                    <h6 className="texto-normal">{usuario?.numeroCedula}</h6>
                                </div>
                                <div className="col-lg-4">
                                    <small>Direccion Particular</small>
                                    <h6 className="texto-normal">{usuario?.direccionParticular}</h6>
                                </div>
                                <div className="col-lg-2">
                                    <small>Teléfono</small>
                                    <h6 className="texto-normal">{usuario?.celular ? usuario?.celular : usuario?.telefonoParticular}</h6>
                                </div>

                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-sm-9 col-lg-7">
                                    <p>¿ Tiene esquema de Vacunación Completa ?</p>
                                </div>
                                <div className="col-sm-2 d-flex">
                                    <div className="form-check mx-2">
                                        <input onChange={this.handleChangeInput} className="form-check-input radio-dosis" type="radio" name="radioDosisCompleta" id="radioSi" value="S" />
                                        <label className="form-check-label" htmlFor="radioSi">
                                            Sí
                                        </label>
                                    </div>
                                    {/*<div className="form-check mx-2">
                                        <input onChange={this.handleChangeInput} className="form-check-input radio-dosis" type="radio" name="radioDosisCompleta" id="radioNo" value="N" />
                                        <label className="form-check-label" htmlFor="radioNo">
                                            No
                                        </label>
                                    </div>*/}
                                </div>
                            </div>                         
                            <div className="importante" style={{padding: "10px"}}>
                                <p>En cumplimiento a la Resolución <span className="text-bold">N° 25.079/2022 (06/01/2022) del INCOOP</span>, al <span className="text-bold">Decreto N° 6563 (04-01/2022) de la Presidencia de la República</span> y al <span className="text-bold">Instructivo Sanitario para Eventos de Concurrencia Masiva </span> vigente <span className="text-bold"> del Ministerio de Salud Pública y Bienestar Social (21/01/2022)</span>, sólo se podrán agendar vacunados con esquema completo de vacunación (3 dosis) o 2 dosis con un tiempo transcurrido menor a 6 meses de aplicación de la 2da dosis, de la vacuna contra la COVID-19, antes de la fecha de asamblea.</p>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="col-lg-12">
                            <div className="row">
                            <div className="col-md-6"></div>    
                            <div className="col-lg-3">
                            <button
                                type="button"
                                className="btn btn-cu-quintary btn-consulta"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                               <FontAwesomeIcon icon={faClose} /> Cerrar
                            </button>
                            </div>
                            <div className="col-lg-3">
                            <button
                                type="button"
                                className="btn btn-cu-primary"
                                data-dismiss="modal"
                                onClick={this.confirmarAgendamiento}
                                disabled={this.state.tieneDosisCompleta === ""}
                            >
                               <FontAwesomeIcon icon={faCheck} /> Confirmar
                            </button>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}